import React, { useState } from 'react';

function BotaoAjuda({ tela }) {
  const [aberto, setAberto] = useState(false);

  // Dicionário de textos chumbados no código (Custo ZERO, velocidade máxima)
  const textosAjuda = {
    postagemLote: {
      titulo: "Como postar ofertas",
      conteudo: (
        <>
          <p><strong>• Produto:</strong> Digite o nome do produto. Se você já tem ele salvo no "Meu Catálogo", o sistema vai sugerir automaticamente e puxar a foto para você.</p>
          <p><strong>• Lojas Destino:</strong> Se a sua loja possui filiais cadastradas, marque em quais unidades essa oferta é válida. O cliente verá o endereço correto dependendo de onde ele está.</p>
          <p><strong>• Preço e Categoria:</strong> Coloque o preço real de prateleira e a categoria correta. Evite fotos com muita poluição visual.</p>
          <p><strong>• Fura-Bolha:</strong> Lojistas Premium têm suas ofertas disparadas para cidades vizinhas automaticamente!</p>
        </>
      )
    },
    catalogo: {
      titulo: "Como usar o Catálogo Padrão",
      conteudo: (
        <>
          <p>Esta tela serve para você cadastrar as fotos e categorias dos produtos que <strong>sempre</strong> entram em promoção na sua loja.</p>
          <p>Ao salvar uma boa foto aqui, você não precisa fazer isso de novo. Na tela de postagem, basta digitar o nome do produto e o sistema preenche o resto em 1 segundo!</p>
        </>
      )
    },
    filiais: {
      titulo: "Como gerenciar suas Filiais",
      conteudo: (
        <>
          <p>Aqui você conecta todas as suas unidades em uma única rede para centralizar os pagamentos e usar as postagens em lote.</p>
          <p><strong>• Como adicionar:</strong> Pegue o ID da filial (lá no aplicativo do celular da loja filial), digite aqui e clique em "Adicionar à Fila".</p>
          <p><strong>• Ativação:</strong> As filiais só ficam ativas e ganham os poderes Premium após você confirmar o pagamento do lote gerado na tela.</p>
          <p><strong>• Desvincular:</strong> Ao remover uma loja da sua rede, o valor para de ser cobrado na próxima fatura, mas ela continua ativa até o fim do ciclo que você já pagou.</p>
        </>
      )
    },
    financeiro: {
      titulo: "Como funciona o seu Financeiro",
      conteudo: (
        <>
          <p>Aqui você acompanha o status da sua assinatura do PromoAlert.</p>
          <p><strong>• Faturas:</strong> Acompanhe seu histórico de pagamentos e links de cobrança.</p>
          <p><strong>• Bloqueios:</strong> Atenção, faturas em atraso suspendem temporariamente a sua capacidade de postar novas ofertas até a regularização. O sistema reconhece o pagamento e libera o acesso automaticamente.</p>
        </>
      )
    }
  };

  const info = textosAjuda[tela];

  // Se a tela não existir no dicionário acima, não renderiza o botão
  if (!info) return null; 

  return (
    <>
      {/* O Botão Discreto de Interrogação */}
      <button 
        onClick={() => setAberto(true)}
        style={{
          background: 'none', border: 'none', color: '#007bff', cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          padding: '0', marginLeft: '10px', verticalAlign: 'middle', transition: '0.2s'
        }}
        title="Precisa de ajuda?"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </button>

      {/* A Janelinha Flutuante (Modal) */}
      {aberto && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 9999
        }}>
          <div className="panel-compact-dialog" style={{
            backgroundColor: '#fff',
            maxWidth: '450px', width: '90%', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }}>
            <h3 style={{ margin: '0 0 14px 0', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px' }}>
              <span style={{ color: '#f59e0b' }}>💡</span> {info.titulo}
            </h3>
            
            <div style={{ fontSize: '14px', lineHeight: '1.5', color: '#4b5563', marginBottom: '16px' }}>
              {info.conteudo}
            </div>

            <div style={{ textAlign: 'right' }}>
              <button className="routine-btn"
                onClick={() => setAberto(false)} 
                style={{
                  backgroundColor: '#007bff', color: '#fff',
                  border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold'
                }}
              >
                Entendi
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BotaoAjuda;
